import { signal } from '@preact/signals-react';
import { MAX_VIEWERS } from 'components/Procedure/SlidesViewer/constants';
import { times } from 'es-toolkit/compat';
import { OverlayAppearancePreferences, OverlayAppearanceType } from 'utils/overlayAppearance';

export const overlayAppearanceProfile = signal<{
  userId?: string;
  status: 'loading' | 'ready' | 'error';
  preferences: OverlayAppearancePreferences;
  error?: Error;
}>({ status: 'loading', preferences: { version: 1, overlays: {} } });

export const viewerAppearanceDrafts = times(MAX_VIEWERS, () =>
  signal<
    | {
        sessionId: string;
        userId: string;
        slideId: string;
        preferences: OverlayAppearancePreferences;
        draftPreferences: OverlayAppearancePreferences;
        baseline: OverlayAppearancePreferences;
        selectedType: OverlayAppearanceType;
      }
    | undefined
  >(undefined)
);

export const getViewerAppearanceDraft = (viewerIndex: number, slideId: string) => {
  const profile = overlayAppearanceProfile.value;
  const draft = viewerAppearanceDrafts[viewerIndex]?.value;
  return draft && draft.userId === profile.userId && draft.slideId === slideId ? draft : undefined;
};

export const getViewerOverlayAppearances = (viewerIndex: number, slideId: string) =>
  (getViewerAppearanceDraft(viewerIndex, slideId)?.preferences ?? overlayAppearanceProfile.value.preferences).overlays;

export const clearViewerAppearanceDraft = (viewerIndex: number, sessionId: string) => {
  if (viewerAppearanceDrafts[viewerIndex]?.peek()?.sessionId === sessionId) {
    viewerAppearanceDrafts[viewerIndex].value = undefined;
  }
};
